export function toggleTheme(){
    return{
        type: "TOGGLE_THEME"
    };
}
